import { ref } from 'vue'

export type GatePanel = 'pick' | 'login'

export const gatePanel = ref<GatePanel>('pick')

export function openGateLogin() {
  gatePanel.value = 'login'
}

export function closeGateLogin() {
  gatePanel.value = 'pick'
}

export function toggleGateLogin() {
  gatePanel.value = gatePanel.value === 'login' ? 'pick' : 'login'
}
